import { useState } from 'react';
import { useToast } from '@chakra-ui/react';
import { getToken } from '../../../../../../services/api';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? process.env.REACT_APP_VERCEL_API_URL 
  : process.env.REACT_APP_LOCAL_API_URL;

const useHandleOpenDetails = () => {
  const [selectedPrecatorio, setSelectedPrecatorio] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const toast = useToast();

  const handleOpenDetails = async (precatorio, onOpen) => {
    setDetailsLoading(true);
    setSelectedPrecatorio(precatorio);
    onOpen();

    // Check if we need to fetch JurisConsult data
    if (!precatorio.qualidade || precatorio.qualidade === '') {
      try {
        const token = getToken();
        const response = await fetch(
          `${API_BASE_URL}/precatorioRJ/jurisconsult/${precatorio._id}`,
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );

        if (response.ok) {
          const data = await response.json();
          if (data.success && data.data) {
            // Update the precatorio with JurisConsult data
            setSelectedPrecatorio({
              ...precatorio,
              jurisConsultData: data.data,
              qualidade: data.data.qualidade
            });
          }
        }
      } catch (error) {
        console.error('Erro ao buscar dados do JurisConsult:', error);
        toast({
          title: 'Aviso',
          description: 'Não foi possível carregar dados do JurisConsult',
          status: 'warning',
          duration: 3000,
          isClosable: true,
        });
      }
    }

    setDetailsLoading(false);
  };

  return {
    selectedPrecatorio,
    detailsLoading,
    handleOpenDetails
  };
};

export default useHandleOpenDetails;